import React from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import { Navbar } from "./Navbar";

export const Header = () => {

  const handleShareClick = () => {
    const textToShare = encodeURIComponent(
      'Check out this awesome link: https://example.com'
    );
    const whatsappUrl = `whatsapp://send?text=${textToShare}`;
    window.location.href = whatsappUrl;
  };
  const phoneNumber = '9926122299'; // Replace with the desired phone number
  const message = 'Hello, I would like to Enquire about your services.'; // Optional: Pre-filled message

  // WhatsApp API URL
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <>
      <header id="topbar" className="topbar">
        <div className="head-container">
          <ul className="left-info">
            <li>
              <a className="topbar-item" href="mailto:earthyfusionpvtltd@gmail.com">
                <i className="fa fa-envelope"></i>
                earthyfusionpvtltd@gmail.com, Info@earthyfusionpvtltd.com
              </a>
            </li>
            <li >
              <a className="topbar-item" href={whatsappUrl} target="_blank" rel="noopener noreferrer" >
                <i class="fa-brands fa-square-whatsapp"></i>+91 992-612-2299
              </a>
            </li>
          </ul>
          <ul className="right-icon">
            <li>
              <a
                className="topbar-item"
                href="https://www.facebook.com/profile.php?id=61566816340589"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Link to="https://www.facebook.com/profile.php?id=61566816340589">
                  <i className="fa-brands fa-facebook-f"></i>
                </Link>
              </a>
            </li>
            <li>
              <a
                className="topbar-item"
                href="https://www.instagram.com/earthyfusion/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Link to="https://www.instagram.com/earthyfusion/">
                  <i className="fa-brands fa-instagram"></i>
                </Link>
              </a>
            </li>
            <li>
              <a
                className="topbar-item"
                href="https://in.linkedin.com/company/earthy-fusion-private-limited/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Link to="https://in.linkedin.com/company/earthy-fusion-private-limited/">
                  <i className="fa-brands fa-linkedin"></i>
                </Link>
              </a>
            </li>
            <li>
              <a
                className="topbar-item"
                href="https://twitter.com/earthyfusion"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Link to="https://twitter.com/earthyfusion">
                  <i className="fa-brands fa-x-twitter"></i>
                </Link>
              </a>
            </li>
            {/* <br /> */}
            {/* Google Translate Dropdown */}
          </ul>
          <ul className="translateer">
            <li>
              <a className="topbar-item">
                <div
                  id="google_translate_element"
                  className="translate-container"
                ></div>
              </a>
            </li>
          </ul>
        </div>
      </header>
      <Navbar />
    </>
  );
};
